import { render, staticRenderFns } from "./FrzPackingArmedPallet.vue?vue&type=template&id=50b0a23a"
import script from "./FrzPackingArmedPallet.vue?vue&type=script&lang=js"
export * from "./FrzPackingArmedPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports